import {ReactElement} from 'react';
import classnames from 'classnames';
import LanguageSelector from '../LanguageSelector';
import HJLogo from '../../../static/images/HJLogo.svg';
import './index.scss';

type Props = {
    logo?: string,
    className?: string,
    isLanguageSelector?: boolean
};

const PageHeader = ({logo, className, isLanguageSelector = true}: Props): ReactElement => {
    const languageSelectorClassName: string = classnames(
        'page-header__language-selector',
        {'page-header__language-selector_hidden': !isLanguageSelector}
    );

    return (
        <div className={classnames('page-header', className)}>
            <div className='page-header-logo'>
                <img className='page-header-logo__img' src={logo ?? HJLogo} alt='HealthJoy logo'/>
            </div>

            <LanguageSelector className={languageSelectorClassName}/>
        </div>
    );
};

export {PageHeader as TestablePageHeader};
export default PageHeader;
